var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { AvatarWithLabel, IconButton, Menu, MenuItem, MenuList } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
// TODO: fix this import
import { redline } from 'shared/domains/documents/components/Preview/Pleditor/plugins/Review';
import { StyledListItem } from '../styled';
import { useRedlines } from '../useGetSources';
export function Source(props) {
    const { text } = props;
    const [open, setOpen] = useState(false);
    const { fetchRedlines } = useRedlines(text);
    const handleClick = () => __awaiter(this, void 0, void 0, function* () {
        const redlines = yield fetchRedlines();
        console.log(redlines);
        if (redlines.length > 0) {
            const candidate = redlines[0];
            console.log(candidate);
            redline(candidate.path, candidate.from, candidate.to);
        }
    });
    return (<StyledListItem>
      <AvatarWithLabel appearance="danger" size="sm" title={text}>
        <Falcon icon="highlighter"/>
      </AvatarWithLabel>
      <Menu open={open} onClose={() => setOpen(false)} target={<IconButton appearance="ghost" onClick={() => setOpen(true)}>
            <Falcon icon="ellipsis-vertical"/>
          </IconButton>}>
        <MenuList>
          <MenuItem onClick={handleClick}>Action 1</MenuItem>
        </MenuList>
      </Menu>
    </StyledListItem>);
}
